import { InferType, number, object, string } from "yup";
import { TWritingType } from "./orders/order";

export type CreateOrders = InferType<typeof CreateOrdersSchema>;

export enum Frequency {
    EVERYDAY = "EVERYDAY",
    EVERY_2_DAYS = "EVERY_2_DAYS",
    EVERY_3_DAYS = "EVERY_3_DAYS",
    ONE_BY_WEEK = "ONE_BY_WEEK",

    EVERY_WEEK = "EVERY_WEEK",
    EVERY_2_WEEK = "EVERY_2_WEEK",
    EVERY_MONTH = "EVERY_MONTH",

    TWO_EVERYDAY = "TWO_EVERYDAY",
}
export type TFrequency = keyof typeof Frequency;

export const CreateOrdersSchema = object({
    keywords: string().required(),
    moneySiteId: number().required("error.order.moneySite.required"),
    writingType: string<TWritingType>()
        .required("error.order.writingType.required")
        .default("AI_AUTO"),
    wordCount: number().default(1000),
    frequency: string<TFrequency>().default(Frequency.EVERY_3_DAYS),
});

export const CreateOrdersBoostSchema = CreateOrdersSchema.omit(["frequency", "writingType"]).concat(
    object({
        writingType: string<TWritingType>()
            .required("error.order.writingType.required")
            .default("AI_MANUAL"),
        frequency: string<TFrequency>().default(Frequency.EVERYDAY),
    })
);
